import { render, staticRenderFns } from "./BrandGreenIsland.vue?vue&type=template&id=1ce48d4d&scoped=true&"
import script from "./BrandGreenIsland.vue?vue&type=script&lang=js&"
export * from "./BrandGreenIsland.vue?vue&type=script&lang=js&"
import style0 from "./BrandGreenIsland.vue?vue&type=style&index=0&id=1ce48d4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce48d4d",
  null
  
)

export default component.exports